import { Component, inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from '../_core/auth.service';
import { MessageService } from 'primeng/api';
import { ToastService } from '../_core/toast.service';
import { BrandingService } from './branding.service';

@Component({
  selector: 'view-redirect',
  styles: [':host img { max-width: 250px; }'],
  template: `
    <div class="d-flex align-items-center justify-content-center w-100 vh-100 p-4">
      @if ($branding.logoUrl(); as logo) {
        <img class="dropShadow" [src]="logo" alt="logo" />
      }
    </div>
  `,
  providers: [],
})
export class RedirectComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private $auth = inject(AuthService);
  private $toast = inject(ToastService);
  public $branding = inject(BrandingService);

  ngOnInit(): void {
    this.doCheck();
  }

  private async doCheck(): Promise<void> {
    const isSignedIn = !!this.$auth.getAuthToken();
    try {
      if (!isSignedIn) {
        this.$auth.removeAuthToken();
        this.goToLogin();
      } else {
        const userData = await this.$auth.isUserDataLoaded();
        if (this.$auth.hasExpiredPassword()) {
          return;
        }
        if (!userData) {
          this.goToLogin({ error: 'data' });
        } else {
          this.router.navigate(['/', 'propiedades']);
        }
      }
    } catch (error: any) {
      this.goToLogin();
      this.$toast.error(error?.error?.message);
    }
  }

  private goToLogin(extra: Params = {}): void {
    const skipWelcome = this.route.snapshot.queryParams?.['skip-welcome'];
    const queryParams: Params = { ...extra };
    if (skipWelcome != null) {
      queryParams['skip-welcome'] = skipWelcome === '' ? '1' : skipWelcome;
    }
    void this.router.navigate(
      ['/', 'login'],
      Object.keys(queryParams).length > 0 ? { queryParams } : undefined,
    );
  }
}
